import request from '@/utils/request'
import URL from '@/api/urlTranslator'

/**
 * 查询交叉委托加价规则列表
 * @param {Object} data 查询参数
 * @returns {Promise}
 */
export function query(data) {
  return request({
    url: URL.mdm.crossDelegationMarkupRule.queryUrl,
    method: 'post',
    data
  })
}

/**
 * 新增交叉委托加价规则
 * @param {Object} data 规则数据
 * @returns {Promise}
 */
export function save(data) {
  return request({
    url: URL.mdm.crossDelegationMarkupRule.saveUrl,
    method: 'post',
    data
  })
}

/**
 * 编辑交叉委托加价规则
 * @param {Object} data 规则数据
 * @returns {Promise}
 */
export function update(data) {
  return request({
    url: URL.mdm.crossDelegationMarkupRule.updateUrl,
    method: 'post',
    data
  })
}

/**
 * 删除交叉委托加价规则
 * @param {String} uuid 规则UUID
 * @returns {Promise}
 */
export function remove(uuid) {
  return request({
    url: URL.mdm.crossDelegationMarkupRule.deleteUrl,
    method: 'post',
    params: { uuid }
  })
}

/**
 * 启用/禁用交叉委托加价规则
 * @param {String} uuid 规则UUID
 * @param {Boolean} enabled 是否启用 true-启用 false-禁用（后端会转换为 '1'/'0'）
 * @returns {Promise}
 */
export function setEnabled(uuid, enabled) {
  // 将 Boolean 转换为 String ('1' 或 '0')
  const enabledStr = enabled ? '1' : '0'
  return request({
    url: URL.mdm.crossDelegationMarkupRule.setEnabledUrl,
    method: 'post',
    params: { uuid, enabled: enabledStr }
  })
}

/**
 * 复制交叉委托加价规则
 * @param {String} uuid 原规则UUID
 * @returns {Promise}
 */
export function copy(uuid) {
  return request({
    url: URL.mdm.crossDelegationMarkupRule.copyUrl,
    method: 'post',
    params: { uuid }
  })
}
